
var SkillsCollection = function(options){
    var oThis = this;

    oThis.defaults = {
        portfolioid: null,
        collectionid: -1,
        filtercontrols: true,
        params: null
    }

    oThis.settings = $.extend( {}, oThis.defaults, options );
    oThis.noncurated = oThis.settings.collectionid == 0;
    oThis.fullset = oThis.settings.collectionid == -1;
    oThis.bCanManage = mantl.userid == mantl.portfolio_user_user;
    oThis.Actions = Reflux.createActions(['fetchSkills']);
    oThis.containerID;
    oThis.modalsID = "skillsCollectionModal";
    oThis.msgStack = new MessageStack();
    oThis.createStore();

    oThis.handleStack = function(){
        oThis.msgStack.Display(); //should we put these in a program builder container?
        oThis.msgStack.Clear();
    }

    //Program Designer
    oThis.SkillsCollection = createReactClass({
        mixins: [Reflux.connect(oThis.WorkStore, 'skills')],

        componentDidUpdate: function(){
            var $component = $(ReactDOM.findDOMNode(this));
            reactFixRowsCols($component);
            $('.collapsible',$component).collapsible();
        },

        componentDidMount: function(){
            var $component = $(ReactDOM.findDOMNode(this));
        },

        getInitialState: function() {
            return {
                filters: {
                    open: false
                }
            }
        },

        render: function() {
            var oComponent = this;
            var emptyMsg = (oThis.fullset) ? "You haven't yet collected any work samples, badges, or endorsements." : "No items linked to skills in this collection.";

            if(this.state.skills){
                var skillsCols = (this.state.filters.open) ? 9 : 12;
                var skills = [];
                for(var i = 0; i < this.state.skills.items.length; i++){
                    var oItem = this.state.skills.items[i];
                    skills.push(<oThis.SkillsCollectionItem item={oItem} key={oItem.id} />);
                }

                if(skills.length > 0){
                    return (
                        <div className="portfolio-content-skills">
                            <ul className="collection collapsible skills-list" data-collapsible="expandable">
                                {skills}
                            </ul>
                        </div>
                    );
                } else {
                    return (
                        <div className="portfolio-content-skills">
                            <div className="alert alert--information text--xl"><h1 className="text--center h4">{emptyMsg}</h1> <img src={mantl.static_url + "assets/images/icon-collection.svg" } className="image--onboarding" alt="Collection Image" /></div>
                        </div>
                    );
                }

            } else {
                return (
                    <div className="portfolio-content-skills">
                        <div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div>
                    </div>
                );
            }

        }
    });


    oThis.SkillsCollectionSkill = createReactClass({
        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
        },

        componentDidUpdate: function() {
        },


        render: function() {
            var oComponent = this;
            return (
                <span className="flag flag--badged">{this.props.skill}</span>
            );

        }
    });


    //Set
    oThis.SkillsCollectionItem = createReactClass({
        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            $('[data-popover="tooltip"]',$component).tooltip();
        },

        componentDidUpdate: function() {
        },

        handleExpand: function(e) {
            var oComponent = this;

            e.stopPropagation();
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            var $item = $(e.target).closest("li");
            var $target = $item.find('.collapsible-body');
            var bEmpty = $target.is(":empty()");

            if(bEmpty){
                $target.append('<div id="work_' + this.props.item.tag + '"></div><div id="badges_' + this.props.item.tag + '"></div><div id="endorsements_' + this.props.item.tag + '"></div>');

                var myWork = new WorkCollection({
                    portfolioid: oThis.settings.portfolioid,
                    collectionid: oThis.settings.collectionid,
                    filtercontrols: false,
                    showOnEmpty: false,
                    params: {
                        skill: this.props.item.tag
                    }
                });
                myWork.renderCollection('work_' + this.props.item.tag);

                var myBadges = new BadgeCollection({
                    portfolioid: oThis.settings.portfolioid,
                    collectionid: oThis.settings.collectionid,
                    filtercontrols: false,
                    showOnEmpty: false,
                    params: {
                        skill: this.props.item.tag
                    }
                });
                myBadges.renderCollection('badges_' + this.props.item.tag);

                var myEndorsements = new EndorsementCollection({
                    portfolioid: oThis.settings.portfolioid,
                    collectionid: oThis.settings.collectionid,
                    params: {
                        skill: this.props.item.tag
                    }
                });
                myEndorsements.renderCollection('endorsements_' + this.props.item.tag);

            } else {

            }

        },

        render: function() {
            var oComponent = this;

            return (
                <li className="collection-item">
                        <button className="collapsible-header clearfix" onClick={this.handleExpand}>
                            <span className="skills-list-label">{this.props.item.tag}</span>
                            <div className="skills-list-stats">
                                <span className="skills-list-work" title="" data-popover="tooltip" data-placement="top" data-original-title="Work Samples">Work Samples</span>
                                <span className="skills-list-count">{this.props.item.work_count}</span>
                                <span className="skills-list-badges" title="" data-popover="tooltip" data-placement="top" data-original-title="Badges">Badges</span>
                                <span className="skills-list-count">{this.props.item.badge_count}</span>
                                <span className="skills-list-endorsements" title="" data-popover="tooltip" data-placement="top" data-original-title="Endorsements">Endorsements</span>
                                <span className="skills-list-count">{this.props.item.endorse_count}</span>
                                <span className="flag flag--badged flag--primary flag--outlined" data-popover="tooltip" data-placement="top" title="" data-original-title="Total Skill Score">{this.props.item.work_count + this.props.item.badge_count + this.props.item.endorse_count}</span>
                            </div>
                        </button>

                        <div className="collapsible-body"></div>
                </li>
            );

        }
    });

};

SkillsCollection.prototype.renderCollection = function(containerID) {
    this.containerID = containerID;
    ReactDOM.render(<this.SkillsCollection />, document.getElementById(this.containerID));
}

//REFLUX STORE
SkillsCollection.prototype.createStore = function() {
    var oThis = this;

    oThis.WorkStore = Reflux.createStore({
        listenables: oThis.Actions,
        skills: {}, //skills store

        init: function() {
        },

        getInitialState: function() {
            this.onFetchSkills();
        },

        onFetchSkills: function() {
            var oStore = this;
            var endpoint;
            if(oThis.fullset){
                endpoint = buildRoute(mantlroutes.portfolio_skills,{ portfolioid: oThis.settings.portfolioid });
            } else if(oThis.noncurated){
                endpoint = buildRoute(mantlroutes.portfolio_noncurated_skills,{ portfolioid: oThis.settings.portfolioid });
            } else {
                endpoint = buildRoute(mantlroutes.portfolio_collection_skills,{ portfolioid: oThis.settings.portfolioid, collectionid: oThis.settings.collectionid });
            }
            httpGet(endpoint).then(
                function(value) {
                    oStore.skills.items = JSON.parse(value);
                    oStore.trigger(oStore.skills);
                })
            .catch(
                function(reason) {
                    console.error('Error loading collection skills.', reason);
                    alertify.error('Unable to load collection skills.')
                });
        }




    });
}
